<template>
    <div>
        <p>
            {{ $t('DeviceTest.SpeakerTest.Confirm') }}
        </p>
        <div class="my-2">
            {{ $t('DeviceTest.SpeakerTest.Select') }}<select id="AudioSelect" name="AudioSelect"></select>
        </div>
        <audio controls
            src="https://tp.hitutoracdm.com/equipment_testing_one/sound/Welcome%20to%20Teaching%20Platform.wav"
            ref="foo"
            controls="true"
            id="AudioPlay" 
        ></audio>
    </div>
</template>

<script>
export default {
    name: 'AudioOutputTest',
    data () {
        return {
            AudioSelect:'',
            AudioSelectName:'',
            AudioList:[],
        }
    },
    mounted(){
        // debugger;
        if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
            // Good to go!
        } else {
            alert('getUserMedia() is not supported by your browser');
        }

        document.querySelector('#AudioPlay').volume = 0.5;
        
        this.$nextTick(function () {
            this.populateAudioList();

            document.querySelector('#AudioSelect').onchange = () => {
                let new_selection = document.querySelector('#AudioSelect').children[
                    document.querySelector('#AudioSelect').selectedIndex
                ].value;
                this.AudioSelectName = document.querySelector('#AudioSelect').children[
                    document.querySelector('#AudioSelect').selectedIndex
                ].text;
                this.SetAudio(new_selection);
            };
            
            navigator.mediaDevices.ondevicechange = event => {
                document.querySelector('#AudioSelect').innerHTML = '';
                this.populateAudioList();
            }   
        })
    },
    methods:{
        populateAudioList:function(){
            var count = 0;
            document.querySelector('#AudioSelect').innerHTML = '';
            this.GLOBAL.AUDIOOutputOK = true;
            var AudioSelect='';
            navigator.mediaDevices.enumerateDevices().then((devices) => {
                // console.log("devices", devices);
                if(devices.filter((x) => x.kind == 'audiooutput').length > 0){
                    AudioSelect = devices.filter((x) => x.kind == 'audiooutput')[0].deviceId;
                    this.AudioSelectName = devices.filter((x) => x.kind == 'audiooutput')[0].label;
                    this.SetAudio(AudioSelect);

                    devices.forEach((device) => {
                        if (device.kind == 'audiooutput') {
                            count +=1;
                            let item = document.createElement('option');
                            item.value = device.deviceId;
                            if(device.label == ""){
                                item.innerHTML = this.$t('DeviceTest.Default')
                            }else{
                                item.innerHTML = device.label;
                            }
                            document.querySelector('#AudioSelect').appendChild(item);
                            // console.log(item);
                        }
                    });
                }else{
                    this.NoDevice();
                }
            })
        },
        SetAudio(AudioSelect){
            this.GLOBAL.selectedAudioOutput = AudioSelect;
            this.GLOBAL.selectedAudioOutput = this.AudioSelectName;
            this.attachSinkId( document.querySelector('#AudioPlay'),AudioSelect);
        },
        NoDevice(){
            let item = document.createElement('option');
            if(this.$root.$refs.OS == 'Mac/iOS'){
                item.innerHTML = this.$t('DeviceTest.Default');
                this.GLOBAL.AUDIOOutputOK = true;
            }else{                
                item.innerHTML = this.$t('DeviceTest.SpeakerTest.NoDevice');
                this.GLOBAL.AUDIOOutputOK = false;
            }
            document.querySelector('#AudioSelect').appendChild(item);
            // this.GLOBAL.AUDIOOutputOK = false;
            this.GLOBAL.selectedAudioOutput = '';
        },
        attachSinkId(element, sinkId) {
            // console.log(element);
            if (typeof element.sinkId !== 'undefined') {
                element
                .setSinkId(sinkId)
                .then(() => {
                    console.log(`Success, audio output device attached: ${sinkId}`)
                })
                .catch((error) => {
                    let errorMessage = error
                    if (error.name === 'SecurityError') {
                        errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`
                    }
                    console.error(errorMessage)
                    // Jump back to first output device in the list as it's the default.
                    // audioOutputSelect.selectedIndex = 0
                })
            } else {
                console.warn('Browser does not support output device selection.')
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/DeviceTestPages/AudioOutputTest.vue